import { Model } from '@vuex-orm/core'
import User from '@/store/models/User'

export default class UserNotification extends Model {
  static entity = 'userNotifications'

  static primaryKey = 'id'

  static fields () {
    return {
      id: this.attr(null),
      title: this.string(''),
      message: this.string(''),
      notificationType: this.string(''),
      chatId: this.attr(null),
      notifiedAt: this.string(''),
      isRead: this.boolean(false),
      relatedId: this.attr(null),
      senderId: this.attr(null),
      additinalId: this.attr(null),
      meta: this.attr(null),
      // toast: this.boolean(false)
    }
  }

  getPostUser() {
    return User.find(this.senderId)
  }
}
